import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';

const API_URL = process.env.API_URL;
const segmentEndpoint = '/category';

export async function getCategoriesList(filter, type) {
  let url = `${API_URL}/admin${segmentEndpoint}/music`;
  if (type === 'missions') {
    url = `${API_URL}/admin${segmentEndpoint}/video`;
  }
  return axios({ url,
    method: 'get',
    params: filter,
    headers: authHeader2() }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function addCategories(data, type) {
  let url = `${API_URL}/admin${segmentEndpoint}/music`;
  if (type === 'missions') {
    url = `${API_URL}/admin${segmentEndpoint}/video`;
  }
  return axios({
    url,
    method: 'post',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function editCategories(data, type) {
  let url = `${API_URL}/admin${segmentEndpoint}/music/${data.id}`;
  if (type === 'missions') {
    url = `${API_URL}/admin${segmentEndpoint}/video/${data.id}`;
  }
  return axios({
    url,
    method: 'PUT',
    data,
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}

export async function deleteCategories(data, type) {
  let url = `${API_URL}/admin${segmentEndpoint}/music/${data.id}`;
  if (type === 'missions') {
    url = `${API_URL}/admin${segmentEndpoint}/video/${data.id}`;
  }
  return axios({
    url,
    method: 'DELETE',
    headers: authHeader2(),
  }).then(response => response.data).catch((err) => {
    throw err.response;
  });
}




// WEBPACK FOOTER //
// ./src/services/categories.js